import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SearchHeader = ({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  viewMode,
  onViewModeChange,
  resultsCount,
  onToggleFilters,
  showMobileFilters
}) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant', icon: 'Target' },
    { value: 'success-rate', label: 'Highest Success Rate', icon: 'Award' },
    { value: 'price-low', label: 'Price: Low to High', icon: 'TrendingUp' },
    { value: 'price-high', label: 'Price: High to Low', icon: 'TrendingDown' },
    { value: 'popularity', label: 'Most Popular', icon: 'Heart' },
    { value: 'newest', label: 'Newest First', icon: 'Clock' }
  ];

  return (
    <div className="bg-white border-b border-accent-200">
      <div className="p-4 lg:p-6">
        {/* Search Bar */}
        <div className="relative mb-4">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Icon name="Search" size={20} className="text-accent-400" />
          </div>
          <Input
            type="search"
            placeholder="Search for specific gifts, brands, or keywords..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10 pr-4 py-3 w-full border-accent-200 focus:border-primary focus:ring-primary rounded-xl"
          />
          {searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
            >
              <Icon name="X" size={16} className="text-accent-400 hover:text-accent-600" />
            </button>
          )}
        </div>

        {/* Natural Language Hint */}
        <div className="mb-4 flex items-start space-x-2 text-sm text-accent-600 bg-blue-50 border border-blue-200 rounded-lg p-3">
          <Icon name="Lightbulb" size={16} className="text-blue-500 mt-0.5 flex-shrink-0" />
          <div>
            <span className="font-medium text-blue-700">💡 Smart Search Tip:</span>
            <span className="ml-1">
              Try natural language! Example: "Christmas gifts for my mom who loves gardening but avoids heavy tools"
            </span>
          </div>
        </div>

        {/* Controls Row */}
        <div className="flex items-center justify-between flex-wrap gap-4">
          {/* Left Side - Results Count & Mobile Filter Toggle */}
          <div className="flex items-center space-x-4">
            <Button
              variant="outline"
              size="sm"
              iconName="Filter"
              iconPosition="left"
              onClick={onToggleFilters}
              className="lg:hidden"
            >
              Filters
            </Button>
            <div className="text-sm text-accent-600">
              <span className="font-medium text-accent-800">{resultsCount.toLocaleString()}</span> gifts found
            </div>
          </div>

          {/* Right Side - Sort & View Controls */}
          <div className="flex items-center space-x-3">
            {/* Sort Dropdown */}
            <div className="relative">
              <select
                value={sortBy}
                onChange={(e) => onSortChange(e.target.value)}
                className="appearance-none bg-white border border-accent-200 rounded-lg px-4 py-2 pr-8 text-sm font-medium text-accent-700 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary cursor-pointer"
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <Icon name="ChevronDown" size={16} className="text-accent-400" />
              </div>
            </div>

            {/* View Mode Toggle */}
            <div className="hidden sm:flex items-center bg-accent-100 rounded-lg p-1">
              <button
                onClick={() => onViewModeChange('grid')}
                className={`p-2 rounded-md transition-all duration-200 ${viewMode === 'grid' ? 'bg-white text-primary shadow-sm' : 'text-accent-600 hover:text-accent-800'
                  }`}
              >
                <Icon name="Grid3X3" size={16} />
              </button>
              <button
                onClick={() => onViewModeChange('list')}
                className={`p-2 rounded-md transition-all duration-200 ${viewMode === 'list' ? 'bg-white text-primary shadow-sm' : 'text-accent-600 hover:text-accent-800'
                  }`}
              >
                <Icon name="List" size={16} />
              </button>
            </div>
          </div>
        </div>

        {/* Active Search Query */}
        {searchQuery && (
          <div className="mt-4 flex items-center space-x-2">
            <span className="text-sm text-accent-600">Searching for:</span>
            <div className="flex items-center bg-primary-50 text-primary px-3 py-1 rounded-full text-sm">
              <span className="font-medium">"{searchQuery}"</span>
              <button
                onClick={() => onSearchChange('')}
                className="ml-2 hover:bg-primary-100 rounded-full p-1 transition-colors duration-200"
              >
                <Icon name="X" size={12} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;